import { Container, Grid } from '@material-ui/core';
import React from 'react';
import './info.scss';

export const Info: React.FC = () => (
  // <></> // todo: omment all below and uncomment this line to remove the info banner
  <>
    <div className="">
      <Container className="info-bar__container">
        <Grid
          container
          item
          xs={12}
          sm={12}
          md={12}
        >
          <p>If you are experiencing delays in returning search results, please try
            <a
              href="https://www.sheepgenetics.org.au/globalassets/sheep-genetics/resources/brochures-and-fact-sheets/clearing-the-cache.pdf"
              target="_blank"
              rel="noreferrer"
            > clearing the cache
            </a>.
          </p>
        </Grid>
      </Container>
    </div>
    {/* todo: If we want to display Important message we use the below code to set the orange banner */}
    {/* <div className="sg-info-bar"> */}
    {/*  <Container className="info-bar__container"> */}
    {/*    <Grid */}
    {/*      container */}
    {/*      item */}
    {/*      xs={12} */}
    {/*      sm={12} */}
    {/*      md={12} */}
    {/*    > */}
    {/*      <h4> */}
    {/*        <br />The MERINOSELECT results from the <strong>7th May (published 15th May)</strong> appear to have */}
    {/*        some errors. Please disregard the published results. */}
    {/*        <br />The Sheep Genetics and AGBU teams are working to correct and will advise when available. */}
    {/*        <br /><br /> */}
    {/*      </h4> */}
    {/*    </Grid> */}
    {/*  </Container> */}
    {/* </div> */}
  </>
);
